import React from "react";
import Loading from "./Loading";

const LoadingWrapper = ({ loading, children, ...props }) => {
  return <>{loading ? <Loading {...props} /> : children}</>;
};

export default LoadingWrapper;
